module.exports = __webpack_public_path__ + "media/images/icon-calendar-f63ffaa234ee4ea16d7c1350c529ba42.svg";